'use client'

import { createStore, Provider } from 'jotai'
import { createContext } from 'react'

const jotaiRootStore = createStore()
export const JotaiRootContext = createContext(jotaiRootStore)

export const JotaiRootProvider = ({
    children,
}: {
    children: React.ReactNode
}) => (
    <Provider store={jotaiRootStore}>
        <JotaiRootContext.Provider value={jotaiRootStore}>
            {children}
        </JotaiRootContext.Provider>
    </Provider>
)
